import type { IGiphyGif } from "@/shared/types";
import { GIF_MASONRY_COLS } from "../constants";
import type { IGifs } from "../types";

interface IProps {
  gifs: IGiphyGif[];
  extend?: boolean;
  cols?: number;
}

export const giphyGifsToGifsCols = ({
  gifs,
  extend,
  cols = GIF_MASONRY_COLS,
}: IProps) => {
  return (prevGifs: IGifs[][]) => {
    const tmp: IGifs[] = [];
    for (const gif of gifs) {
      if (gif.type === "gif") {
        tmp.push({
          id: gif.id,
          url: gif.images.fixed_width.webp,
          alt: gif.alt_text,
          width: Number(gif.images.original.width),
          height: Number(gif.images.original.height),
          userName: gif.username,
          userUrl: gif.user?.profile_url,
          preview: {
            url: gif.images.fixed_width.webp,
            width: Number(gif.images.fixed_width.width),
            height: Number(gif.images.fixed_width.height),
            webp: gif.images.fixed_width.webp,
            mp4: gif.images.fixed_width.mp4,
          },
        });
      }
    }

    if (extend) {
      const currentColumns: IGifs[][] = Array.from(
        { length: cols },
        (_, idx) => [...(prevGifs[idx] ?? [])],
      );

      tmp.forEach((gif, index) => {
        const totalItems = prevGifs.reduce((sum, col) => sum + col.length, 0);
        const columnIndex = (totalItems + index) % cols;
        currentColumns[columnIndex].push(gif);
      });
      return currentColumns;
    }

    const newColumns: IGifs[][] = Array.from({ length: cols }, () => []);
    tmp.forEach((gif, index) => {
      const columnIndex = index % cols;
      newColumns[columnIndex].push(gif);
    });
    return newColumns;
  };
};
